<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  accountRecordTypeList,
} from 'api/user';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        businessNumberOptions: [],
        form: [
          { // 业务月份
            label: '业务月份',
            value: 'month',
            type: 'date',
            placeholder: '请选择业务月份',
            default: new Date(),
            attr: {
              type: 'month',
            },
            onChange: () => {
              this.handleBusinessNumberOptions();
            },
          },
          { // 业务类型
            label: '业务类型',
            value: 'businessNumber',
            type: 'select',
            placeholder: '请选择业务类型',
          },
          { // 车队名称
            label: '车队名称',
            value: 'teamName',
            type: 'input',
            placeholder: '请输入车队名称',
          },
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.month = this.formatDate(searchBoxData.month, 3);
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    async handleBusinessNumberOptions () {
      const month = this.$refs.searchBox.getVal('month');
      const res = await accountRecordTypeList({
        month: this.formatDate(month, 3),
      });
      this.searchBoxData.businessNumberOptions = [
        {
          label: '全部',
          value: -1,
        },
        ...res.items.map((item) => ({
          label: item.businessNumberName,
          value: item.businessNumber,
        })),
      ];
    },
  },
  mounted () {
    this.handleBusinessNumberOptions();
  },
};
</script>

<style lang="scss" scoped>
</style>
